import { hashKey, type QueryKey } from "@tanstack/react-query";

export const isSameQueryKey = (queryKey1: QueryKey, queryKey2: QueryKey) => hashKey(queryKey1) === hashKey(queryKey2);
